export const colorGetters = {
  toolbarColor: (state) => {
    // This is to standardize toolbar shade color
    // For default shading, just get from state mainColor
    // let result = state.mainColor + ' darken-4'
    let result = state.mainColor
    return result
  }
}
